!function (e, r) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion"), require("@leafygreen-ui/palette"), require("@leafygreen-ui/lib"), require("@leafygreen-ui/hooks"), require("@leafygreen-ui/box"), require("@leafygreen-ui/leafygreen-provider"), require("@leafygreen-ui/tokens"), require("lodash/omit"));else if ("function" == typeof define && define.amd) define(["react", "prop-types", "@leafygreen-ui/emotion", "@leafygreen-ui/palette", "@leafygreen-ui/lib", "@leafygreen-ui/hooks", "@leafygreen-ui/box", "@leafygreen-ui/leafygreen-provider", "@leafygreen-ui/tokens", "lodash/omit"], r);else {
    var t = "object" == typeof exports ? r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion"), require("@leafygreen-ui/palette"), require("@leafygreen-ui/lib"), require("@leafygreen-ui/hooks"), require("@leafygreen-ui/box"), require("@leafygreen-ui/leafygreen-provider"), require("@leafygreen-ui/tokens"), require("lodash/omit")) : r(e.react, e["prop-types"], e["@leafygreen-ui/emotion"], e["@leafygreen-ui/palette"], e["@leafygreen-ui/lib"], e["@leafygreen-ui/hooks"], e["@leafygreen-ui/box"], e["@leafygreen-ui/leafygreen-provider"], e["@leafygreen-ui/tokens"], e["lodash/omit"]);

    for (var n in t) {
      ("object" == typeof exports ? exports : e)[n] = t[n];
    }
  }
}("undefined" != typeof self ? self : this, function (e, r, t, n, o, u, i, l, a, f) {
  return function (e) {
    var r = {};

    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        enumerable: !0,
        get: n
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, r) {
      if (1 & r && (e = t(e)), 8 & r) return e;
      if (4 & r && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (t.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & r && "string" != typeof e) for (var o in e) {
        t.d(n, o, function (r) {
          return e[r];
        }.bind(null, o));
      }
      return n;
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, t.p = "", t(t.s = 5);
  }([function (r, t) {
    r.exports = e;
  }, function (e, r, t) {
    "use strict";

    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    }), r.default = r.Mode = void 0;

    var o,
        u = function (e) {
      if (e && e.__esModule) return e;
      if (null === e || "object" !== n(e) && "function" != typeof e) return {
        default: e
      };
      var r = y();
      if (r && r.has(e)) return r.get(e);
      var t = {},
          o = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var u in e) {
        if (Object.prototype.hasOwnProperty.call(e, u)) {
          var i = o ? Object.getOwnPropertyDescriptor(e, u) : null;
          i && (i.get || i.set) ? Object.defineProperty(t, u, i) : t[u] = e[u];
        }
      }

      t.default = e, r && r.set(e, t);
      return t;
    }(t(0)),
        i = p(t(2)),
        l = t(3),
        a = t(4),
        f = t(6),
        c = t(7),
        s = p(t(8)),
        d = p(t(12));

    function p(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function y() {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap();
      return y = function y() {
        return e;
      }, e;
    }

    function b() {
      return (b = Object.assign || function (e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = arguments[r];

          for (var n in t) {
            Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function g(e, r) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, r) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var t = [],
            n = !0,
            o = !1,
            u = void 0;

        try {
          for (var i, l = e[Symbol.iterator](); !(n = (i = l.next()).done) && (t.push(i.value), !r || t.length !== r); n = !0) {
            ;
          }
        } catch (e) {
          o = !0, u = e;
        } finally {
          try {
            n || null == l.return || l.return();
          } finally {
            if (o) throw u;
          }
        }

        return t;
      }(e, r) || function (e, r) {
        if (!e) return;
        if ("string" == typeof e) return v(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === t && e.constructor && (t = e.constructor.name);
        if ("Map" === t || "Set" === t) return Array.from(t);
        if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return v(e, r);
      }(e, r) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function v(e, r) {
      (null == r || r > e.length) && (r = e.length);

      for (var t = 0, n = new Array(r); t < r; t++) {
        n[t] = e[t];
      }

      return n;
    }

    function m(e, r) {
      if (null == e) return {};

      var t,
          n,
          o = function (e, r) {
        if (null == e) return {};
        var t,
            n,
            o = {},
            u = Object.keys(e);

        for (n = 0; n < u.length; n++) {
          t = u[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
        }

        return o;
      }(e, r);

      if (Object.getOwnPropertySymbols) {
        var u = Object.getOwnPropertySymbols(e);

        for (n = 0; n < u.length; n++) {
          t = u[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
        }
      }

      return o;
    }

    function O() {
      var e = M(["\n  cursor: not-allowed;\n"]);
      return O = function O() {
        return e;
      }, e;
    }

    function h() {
      var e = M(["\n  list-style: none;\n  padding: 0;\n  display: flex;\n  width: 100%;\n"]);
      return h = function h() {
        return e;
      }, e;
    }

    function j(e, r, t) {
      return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }

    function x() {
      var e = M(["\n      border-bottom: 1px solid ", ";\n    "]);
      return x = function x() {
        return e;
      }, e;
    }

    function k() {
      var e = M(["\n      color: ", ";\n    "]);
      return k = function k() {
        return e;
      }, e;
    }

    function P() {
      var e = M(["\n      color: ", ";\n\n      &:hover:not(:focus) {\n        color: ", ";\n      }\n    "]);
      return P = function P() {
        return e;
      }, e;
    }

    function w() {
      var e = M(["\n      border-bottom: 1px solid ", ";\n    "]);
      return w = function w() {
        return e;
      }, e;
    }

    function C() {
      var e = M(["\n      color: ", ";\n    "]);
      return C = function C() {
        return e;
      }, e;
    }

    function S() {
      var e = M(["\n      color: ", ";\n\n      &:hover:not(:focus) {\n        color: ", ";\n      }\n    "]);
      return S = function S() {
        return e;
      }, e;
    }

    function M(e, r) {
      return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(r)
        }
      }));
    }

    var _ = {
      Dark: "dark",
      Light: "light"
    };
    r.Mode = _;
    var T = (j(o = {}, _.Light, {
      activeStyle: (0, l.css)(S(), a.uiColors.green.dark2, a.uiColors.green.dark2),
      disabledColor: (0, l.css)(C(), a.uiColors.gray.light1),
      underlineColor: (0, l.css)(w(), a.uiColors.gray.light2)
    }), j(o, _.Dark, {
      activeStyle: (0, l.css)(P(), a.uiColors.green.light2, a.uiColors.green.light2),
      disabledColor: (0, l.css)(k(), a.uiColors.gray.dark1),
      underlineColor: (0, l.css)(x(), a.uiColors.gray.dark2)
    }), o),
        q = (0, l.css)(h()),
        E = (0, l.css)(O());

    function D(e) {
      var r = e.children,
          t = e.setSelected,
          n = e.selected,
          o = e.className,
          i = e.darkMode,
          a = void 0 !== i && i,
          p = e.as,
          y = void 0 === p ? "button" : p,
          v = m(e, ["children", "setSelected", "selected", "className", "darkMode", "as"]),
          O = u.default.Children.toArray(r),
          h = "number" == typeof n,
          x = g((0, u.useState)(O.findIndex(function (e) {
        return e.props.default || 0;
      })), 2),
          k = x[0],
          P = x[1],
          w = h ? n : k,
          C = h ? t : P;

      var S = function S() {
        var e = O.filter(function (e) {
          return !e.props.disabled;
        }).map(function (e) {
          return O.indexOf(e);
        });
        return [e, e.indexOf(w)];
      };

      (0, c.useEventListener)("keydown", function (e) {
        if (!e.metaKey && !e.ctrlKey) if (e.keyCode === f.keyMap.ArrowRight) {
          var r = g(S(), 2),
              t = r[0],
              n = r[1];
          C(t[(n + 1) % t.length]);
        } else if (e.keyCode === f.keyMap.ArrowLeft) {
          var o = g(S(), 2),
              u = o[0],
              i = o[1];
          C(u[(i - 1 + u.length) % u.length]);
        }
      });
      var M = u.default.Children.map(r, function (e, r) {
        return (0, f.isComponentType)(e, "Tab") ? u.default.cloneElement(e, {
          key: r,
          ariaControl: "tab-".concat(r),
          selected: w === r
        }) : e;
      }),
          D = a ? _.Dark : _.Light;
      return u.default.createElement("div", b({}, v, {
        className: o
      }), u.default.createElement("div", {
        className: (0, l.cx)(q, T[D].underlineColor),
        role: "tablist",
        tabIndex: 0
      }, M.map(function (e, r) {
        var t,
            n = e.props,
            o = n.selected,
            i = n.disabled,
            f = m(n, ["selected", "disabled"]),
            c = (0, d.default)(f, ["ariaControl", "children", "name", "default"]);
        return u.default.createElement(s.default, b({}, c, {
          key: r,
          ariaControl: "tab-".concat(r),
          disabled: i,
          selected: o,
          index: r,
          as: y,
          darkMode: a,
          className: (0, l.cx)((t = {}, j(t, T[D].activeStyle, o), j(t, (0, l.cx)(T[D].disabledColor, E), i), t)),
          onClick: i ? void 0 : function (e) {
            return function (e, r) {
              C(r);
            }(0, r);
          }
        }), e.props.name);
      })), M);
    }

    D.displayName = "Tabs", D.propTypes = {
      children: i.default.node,
      setSelected: i.default.func,
      selected: i.default.number,
      className: i.default.string,
      as: i.default.oneOfType([i.default.string, i.default.func])
    };
    var N = D;
    r.default = N;
  }, function (e, t) {
    e.exports = r;
  }, function (e, r) {
    e.exports = t;
  }, function (e, r) {
    e.exports = n;
  }, function (e, r, t) {
    "use strict";

    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    }), Object.defineProperty(r, "Tabs", {
      enumerable: !0,
      get: function get() {
        return u.default;
      }
    }), Object.defineProperty(r, "Tab", {
      enumerable: !0,
      get: function get() {
        return i.default;
      }
    }), Object.defineProperty(r, "TabProps", {
      enumerable: !0,
      get: function get() {
        return i.TabProps;
      }
    });

    var o,
        u = (o = t(1)) && o.__esModule ? o : {
      default: o
    },
        i = function (e) {
      if (e && e.__esModule) return e;
      if (null === e || "object" !== n(e) && "function" != typeof e) return {
        default: e
      };
      var r = l();
      if (r && r.has(e)) return r.get(e);
      var t = {},
          o = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var u in e) {
        if (Object.prototype.hasOwnProperty.call(e, u)) {
          var i = o ? Object.getOwnPropertyDescriptor(e, u) : null;
          i && (i.get || i.set) ? Object.defineProperty(t, u, i) : t[u] = e[u];
        }
      }

      t.default = e, r && r.set(e, t);
      return t;
    }(t(13));

    function l() {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap();
      return l = function l() {
        return e;
      }, e;
    }
  }, function (e, r) {
    e.exports = o;
  }, function (e, r) {
    e.exports = u;
  }, function (e, r, t) {
    "use strict";

    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    Object.defineProperty(r, "__esModule", {
      value: !0
    }), r.default = void 0;

    var o,
        u = function (e) {
      if (e && e.__esModule) return e;
      if (null === e || "object" !== n(e) && "function" != typeof e) return {
        default: e
      };
      var r = d();
      if (r && r.has(e)) return r.get(e);
      var t = {},
          o = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var u in e) {
        if (Object.prototype.hasOwnProperty.call(e, u)) {
          var i = o ? Object.getOwnPropertyDescriptor(e, u) : null;
          i && (i.get || i.set) ? Object.defineProperty(t, u, i) : t[u] = e[u];
        }
      }

      t.default = e, r && r.set(e, t);
      return t;
    }(t(0)),
        i = t(3),
        l = t(4),
        a = (o = t(9)) && o.__esModule ? o : {
      default: o
    },
        f = t(10),
        c = t(11),
        s = t(1);

    function d() {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap();
      return d = function d() {
        return e;
      }, e;
    }

    function p() {
      return (p = Object.assign || function (e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = arguments[r];

          for (var n in t) {
            Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function y(e, r) {
      var t = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        r && (n = n.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, n);
      }

      return t;
    }

    function b(e, r, t) {
      return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }

    function g(e, r) {
      if (null == e) return {};

      var t,
          n,
          o = function (e, r) {
        if (null == e) return {};
        var t,
            n,
            o = {},
            u = Object.keys(e);

        for (n = 0; n < u.length; n++) {
          t = u[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
        }

        return o;
      }(e, r);

      if (Object.getOwnPropertySymbols) {
        var u = Object.getOwnPropertySymbols(e);

        for (n = 0; n < u.length; n++) {
          t = u[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
        }
      }

      return o;
    }

    function v() {
      var e = w(["\n  background-color: transparent;\n  border: 0px;\n  padding: 12px 16px;\n  text-decoration: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 300px;\n  transition: 150ms color ease-in-out;\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 16px;\n  position: relative;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 4px;\n    border-radius: 4px 4px 0 0;\n    transition: all 150ms ease-in-out;\n    background-color: transparent;\n    transform: scaleX(0.8);\n  }\n\n  &:hover:after {\n    transform: scaleX(0.95);\n  }\n"]);
      return v = function v() {
        return e;
      }, e;
    }

    function m() {
      var e = w(["\n  &:after {\n    transform: scaleX(1);\n    background-color: ", ";\n  }\n\n  &:hover:after {\n    transform: scaleX(1);\n    background-color: ", ";\n  }\n"]);
      return m = function m() {
        return e;
      }, e;
    }

    function O() {
      var e = w(["\n      &:focus {\n        color: #43b1e5;\n\n        &:after {\n          background-color: ", ";\n        }\n      }\n    "]);
      return O = function O() {
        return e;
      }, e;
    }

    function h() {
      var e = w(["\n      &:hover {\n        cursor: pointer;\n\n        &:not(:focus) {\n          color: ", ";\n\n          &:after {\n            background-color: ", ";\n          }\n        }\n      }\n    "]);
      return h = function h() {
        return e;
      }, e;
    }

    function j() {
      var e = w(["\n      color: ", ";\n    "]);
      return j = function j() {
        return e;
      }, e;
    }

    function x() {
      var e = w(["\n      &:focus {\n        color: ", ";\n\n        &:after {\n          background-color: ", ";\n        }\n      }\n    "]);
      return x = function x() {
        return e;
      }, e;
    }

    function k() {
      var e = w(["\n      &:hover {\n        cursor: pointer;\n\n        &:not(:focus) {\n          color: ", ";\n\n          &:after {\n            background-color: ", ";\n          }\n        }\n      }\n    "]);
      return k = function k() {
        return e;
      }, e;
    }

    function P() {
      var e = w(["\n      color: ", ";\n    "]);
      return P = function P() {
        return e;
      }, e;
    }

    function w(e, r) {
      return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(r)
        }
      }));
    }

    var C = {
      light: {
        listTitleColor: (0, i.css)(P(), l.uiColors.gray.dark1),
        listTitleHover: (0, i.css)(k(), l.uiColors.gray.dark3, l.uiColors.gray.light2),
        listTitleFocus: (0, i.css)(x(), l.uiColors.blue.base, l.uiColors.blue.base)
      },
      dark: {
        listTitleColor: (0, i.css)(j(), l.uiColors.gray.light1),
        listTitleHover: (0, i.css)(h(), l.uiColors.white, l.uiColors.gray.dark1),
        listTitleFocus: (0, i.css)(O(), l.uiColors.blue.base)
      }
    },
        S = (0, i.css)(m(), l.uiColors.green.base, l.uiColors.green.base),
        M = (0, i.css)(v(), c.fontFamilies.default),
        _ = function _(e) {
      var r,
          t,
          n = e.selected,
          o = void 0 !== n && n,
          l = e.disabled,
          c = void 0 !== l && l,
          d = e.children,
          v = e.className,
          m = e.ariaControl,
          O = (e.index, e.darkMode),
          h = g(e, ["selected", "disabled", "children", "className", "ariaControl", "index", "darkMode"]),
          j = (0, f.useUsingKeyboardContext)().usingKeyboard,
          x = (0, u.useRef)(null),
          k = O ? s.Mode.Dark : s.Mode.Light;
      (0, u.useEffect)(function () {
        !c && o && x.current && x.current.focus();
      }, [c, o]);

      var P = function (e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = null != arguments[r] ? arguments[r] : {};
          r % 2 ? y(Object(t), !0).forEach(function (r) {
            b(e, r, t[r]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : y(Object(t)).forEach(function (r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
          });
        }

        return e;
      }((t = {
        className: (0, i.cx)(M, C[k].listTitleColor, (r = {}, b(r, C[k].listTitleHover, !c), b(r, S, o), b(r, C[k].listTitleFocus, j), r), v),
        role: "tab"
      }, b(t, "aria-controls", m), b(t, "aria-selected", o), b(t, "aria-disabled", c), b(t, "tabIndex", o ? 0 : -1), t), h);

      return "string" == typeof h.href ? u.default.createElement(a.default, p({
        as: "a",
        ref: x
      }, P), d) : u.default.createElement(a.default, p({
        as: "button",
        ref: x
      }, P), d);
    };

    _.displayName = "TabTitle";
    var T = _;
    r.default = T;
  }, function (e, r) {
    e.exports = i;
  }, function (e, r) {
    e.exports = l;
  }, function (e, r) {
    e.exports = a;
  }, function (e, r) {
    e.exports = f;
  }, function (e, r, t) {
    "use strict";

    Object.defineProperty(r, "__esModule", {
      value: !0
    }), r.default = void 0;
    var n = u(t(0)),
        o = u(t(2));

    function u(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function i() {
      return (i = Object.assign || function (e) {
        for (var r = 1; r < arguments.length; r++) {
          var t = arguments[r];

          for (var n in t) {
            Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function l(e, r) {
      if (null == e) return {};

      var t,
          n,
          o = function (e, r) {
        if (null == e) return {};
        var t,
            n,
            o = {},
            u = Object.keys(e);

        for (n = 0; n < u.length; n++) {
          t = u[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
        }

        return o;
      }(e, r);

      if (Object.getOwnPropertySymbols) {
        var u = Object.getOwnPropertySymbols(e);

        for (n = 0; n < u.length; n++) {
          t = u[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
        }
      }

      return o;
    }

    function a(e) {
      var r = e.selected,
          t = e.children,
          o = e.ariaControl,
          u = l(e, ["selected", "children", "ariaControl"]);
      return r ? (delete u.default, delete u.name, n.default.createElement("div", i({}, u, {
        "aria-controls": o,
        id: o,
        role: "tabpanel"
      }), t)) : null;
    }

    a.displayName = "Tab", a.propTypes = {
      selected: o.default.bool,
      children: o.default.node,
      name: o.default.oneOfType([o.default.string, o.default.node]),
      content: o.default.node,
      disabled: o.default.bool,
      ariaControl: o.default.string
    };
    var f = a;
    r.default = f;
  }]);
});